import SalesApi from "../../apis/Sales";
import CotizacionesApi from "../../apis/Cotizaciones";
import ArrayTools from "../../helpers/ArrayTools";
import NumberTools from "../../helpers/NumberTools";

export default {
  namespaced: true,
  state: {
    cart: [],
    modality: null,
    product: null,
    subtotal: null,
    discount: null,
    igv: null,
    total: null,
    customer: null,
    doctor: null,
    company: null,
    client: null,
    sale: [],
    cotizacion: null,
    status_operation: false,
    imeis_selected: [],
    view_prices: false,
    type_operation: "sale",
    orders: [],
    order: null,
    detail: [],
    date_invoice: null,
    rounding: null,
    total_rounded: null,
    total_gratuitas: null,
    customer_id: null,
    doctor_id: null,
    company_id: null,
    sale_station: null,
    worker: null,
    worker_id: null,
    selected_sale: null,
    last_order_code: null,
    client_id: null,
    select_cotizacion:null,
    paginated:{}
  },
  mutations: {
    set_status_operation(state, value) {
      state.status_operation = value;
    },
    set_sale(state, data) {
      state.sale = data;
    },
    set_selected_sale(state, selected_sale) {
      state.selected_sale = selected_sale;
    },
    set_cart(state, data) {
      state.cart = data;
    },
    set_add_product_to_cart(state, product) {
      state.cart.push(product);
    },
    set_modality(state, data) {
      state.modality = data;
    },
    set_product(state, data) {
      state.product = data;
    },
    set_subtotal(state, value) {
      state.subtotal = value;
    },
    set_igv(state, value) {
      state.igv = value;
    },
    set_total(state, value) {
      state.total = value;
    },
    delete_item_cart(state, index) {
      state.cart.splice(index, 1);
    },
    replace_item_cart(state, data) {
      state.cart.splice(data.index, 1, data.product);
    },
    set_customer(state, data) {
      state.customer = data;
    },
    set_doctor(state, data) {
      state.doctor = data;
    },
    set_client(state, data) {
      state.client = data;
    },
    set_client_id(state, value) {
      state.client_id = value;
    },
    set_select_cotizacion(state, data) {
      state.select_cotizacion = data;
    },
    set_company(state, data) {
      state.company = data;
    },
    set_imeis_selected(state, data) {
      state.imeis_selected = data;
    },
    add_item_imei(state, value) {
      state.imeis_selected.push(value);
    },
    delete_item_imei(state, index) {
      state.imeis_selected.splice(index, 1);
    },
    set_view_prices(state, value) {
      state.view_prices = value;
    },
    set_discount(state, value) {
      state.discount = value;
    },
    set_type_operation(state, value) {
      state.type_operation = value;
    },
    set_orders(state, data) {
      state.orders = data;
    },
    set_order(state, data) {
      state.order = data;
    },
    set_detail(state, data) {
      state.detail = data;
    },
    set_date_invoice(state, value) {
      state.date_invoice = value;
    },
    set_rounding(state, value) {
      state.rounding = value;
    },
    set_total_rounded(state, value) {
      state.total_rounded = value;
    },
    set_total_gratuitas(state, value) {
      state.total_gratuitas = value;
    },
    set_customer_id(state, value) {
      state.customer_id = value;
    },
    set_doctor_id(state, value) {
      state.doctor_id = value;
    },
    set_company_id(state, value) {
      state.company_id = value;
    },
    set_sale_station(state, value) {
      state.sale_station = value;
    },
    set_worker(state, data) {
      state.worker = data;
    },
    set_worker_id(state, value) {
      state.worker_id = value;
    },
    set_last_order_code(state, value) {
      state.last_order_code = value;
    },
    set_clear_data(state){
      state.cart = []

      state.customer = null
      state.customer_id =  null
      state.doctor = null
      state.doctor_id = null
      state.company =  null
      state.company_id = null
      state.discount =  null
      state.subtotal =  null
      state.igv =  null
      state.total =  null
      state.rounding =  null
      state.total_rounded =  null
      state.total_gratuitas =  null
      state.sale_station =  null
      state.worker =  null
      state.worker_id =  null
      state.client_id =  null
      state.client = null
    },
    set_clear_amount(state){
      state.customer = null
      state.customer_id =  null
      state.doctor = null
      state.doctor_id = null
      state.company =  null
      state.company_id = null
      state.discount =  null
      state.subtotal =  null
      state.igv =  null
      state.total =  null
      state.rounding =  null
      state.total_rounded =  null
      state.total_gratuitas =  null
      state.sale_station =  null
      state.worker =  null
      state.worker_id =  null
    },
    set_get_sale_by_station(state, data){
      state.sale_station = data.set_sale_station
      state.cart = data.set_cart
      state.customer_id = data.set_customer_id
      state.customer = data.set_customer
      state.worker = data.set_worker
      state.worker_id = data.set_worker_id
    },
    set_calculated_amount(state, data){
      state.discount = data.set_discount
      state.subtotal = data.set_subtotal
      state.igv = data.set_igv
      state.total = data.set_total
      state.rounding = data.set_rounding
      state.total_rounded = data.set_total_rounded
      state.total_gratuitas = data.set_total_gratuitas
    },
    set_paginated (state, data) {
      state.paginated =  data
    }
  },
  actions: {
    emptySales({ commit }) {
      commit("set_sale", []);
    },
    selectSale({ commit }, sale) {
      commit("set_selected_sale", sale);
    },
    setViewPrices({ commit }, value) {
      commit("set_view_prices", value);
    },
    run_set_status_operation({ commit }, value) {
      commit("set_status_operation", value);
    },
    run_set_sale({ commit }, data) {
      commit("set_sale", data);
    },
    clear_set_select_cotizacion({ commit } , data){
      commit("set_select_cotizacion", data);
    },
    clearData({ commit }) {
      commit('set_clear_data')
      // commit("set_cart", []);

      // commit("set_customer", null);
      // commit("set_customer_id", null);
      // commit("set_doctor", null);
      // commit("set_doctor_id", null);
      // commit("set_company", null);
      // commit("set_company_id", null);
      // commit("set_discount", null);
      // commit("set_subtotal", null);
      // commit("set_igv", null);
      // commit("set_total", null);
      // commit("set_rounding", null);
      // commit("set_total_rounded", null);
      // commit("set_total_gratuitas", null);
      // commit("set_sale_station", null);
      // commit("set_worker", null);
      // commit("set_worker_id", null);

      // commit("set_client_id", null);
    },
    clearAmount({ commit }) {
      commit('set_clear_amount')
      // commit("set_customer", null);
      // commit("set_customer_id", null);
      // commit("set_doctor", null);
      // commit("set_doctor_id", null);
      // commit("set_company", null);
      // commit("set_company_id", null);
      // commit("set_discount", null);
      // commit("set_subtotal", null);
      // commit("set_igv", null);
      // commit("set_total", null);
      // commit("set_rounding", null);
      // commit("set_total_rounded", null);
      // commit("set_total_gratuitas", null);
      // commit("set_sale_station", null);
      // commit("set_worker", null);
      // commit("set_worker_id", null);
    },
    select_customer({ commit }, customer) {
      commit("set_customer", customer);
      if (customer) {
        commit("set_customer_id", customer.id);
      } else {
        commit("set_customer_id", null);
      }
    },
    select_doctor({ commit }, doctor) {
      commit("set_doctor", doctor);
      if (doctor) {
        commit("set_doctor_id", doctor.id);
      } else {
        commit("set_doctor_id", null);
      }
    },
    select_company({ commit }, company) {
      commit("set_company", company);
      if (company) {
        commit("set_company_id", company.id);
      } else {
        commit("set_company_id", null);
      }
    },
    select_client({ commit }, client) {
      commit("set_client", client);
      if (client) {
        commit("set_client_id", client.id);
      } else {
        commit("set_client_id", null);
      }
    },
    selectWorker({ commit }, worker) {
      commit("set_worker", worker);
      if (worker) {
        commit("set_worker_id", worker.id);
      } else {
        commit("set_worker_id", null);
      }
    },
    setDateInvoice({ commit }, value) {
      commit("set_date_invoice", value);
    },
    add_product_to_cart({ commit, dispatch }, product) {
      commit("set_add_product_to_cart", product);
      dispatch("calulateAmounts");
    },
    delete_product_cart({ commit, dispatch, state }, product) {
      let index = ArrayTools.getIndexById(
        state.cart,
        product.id,
        product.type_item
      );
      commit("delete_item_cart", index);
      dispatch("calulateAmounts");
    },
    replace_product_cart({ commit, dispatch, state }, product) {
      let index = ArrayTools.getIndexById(
        state.cart,
        product.id,
        product.type_item
      );
      let data = {
        index: index,
        product: product,
      };
      commit("replace_item_cart", data);
      dispatch("calulateAmounts");
    },
    run_set_cart({ commit }, data) {
      commit("set_cart", data);
    },
    select_modality({ commit }, data) {
      commit("set_modality", data);
    },
    select_product({ commit }, data) {
      commit("set_product", data);
    },
    calulateAmounts({ commit, state }) {
      let sum_discount = 0;
      let sum_subtotal = 0;
      let sum_igv = 0;
      let sum_total = 0;
      let sum_total_gratuitas = 0;

      state.cart.forEach((element) => {
        if (element.is_bonus == true) {
          sum_total_gratuitas =
            sum_total_gratuitas + parseFloat(element.subtotal);
        } else {
          sum_subtotal =
            sum_subtotal +
            parseFloat(element.subtotal) -
            NumberTools.getNumberDecimalValue(element.discount_value);
          sum_discount =
            sum_discount +
            NumberTools.getNumberDecimalValue(element.discount_value);
        }
      });

      sum_total = sum_subtotal;
      let amount_subtotal = Math.round((sum_subtotal / 1.18) * 100) / 100;
      sum_igv = Math.round((sum_total - amount_subtotal) * 100) / 100;

      //calculo de redondeo a 1 decimal
      let amount_total_rounded = Math.round(sum_total * 10) / 10;
      let amoutn_rounded = Math.round(amount_total_rounded * 100) / 100;
      let amount_rounding =
        Math.round((amoutn_rounded - sum_total) * 100) / 100;

      let amount_gratuitas = Math.round(sum_total_gratuitas * 100) / 100;

      const data = {
        set_discount: sum_discount,
        set_subtotal: amount_subtotal,
        set_igv: sum_igv,
        set_total: sum_total,
        set_rounding: amount_rounding,
        set_total_rounded: amoutn_rounded,
        set_total_gratuitas: amount_gratuitas
      }
      commit("set_calculated_amount", data);
      // commit("set_discount", sum_discount);
      // commit("set_subtotal", amount_subtotal);
      // commit("set_igv", sum_igv);
      // commit("set_total", sum_total);
      // commit("set_rounding", amount_rounding);
      // commit("set_total_rounded", amoutn_rounded);
      // commit("set_total_gratuitas", amount_gratuitas);
    },
    async storeCotizacion({ commit, dispatch }, cotizacion) {
      return await CotizacionesApi.store(cotizacion)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message:
                "El registro de la cotización se realizó de forma correcta.",
            },
            { root: true }
          );
          //console.log(response.data);
          commit("set_status_operation", true);
          commit("set_sale", response.data);
          dispatch("clearData");
          //dispatch('getLastOrderCode');
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al registrar la cotización, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    setTypeOperation({ commit }, value) {
      commit("set_type_operation", value);
    },
    async getOrders({ commit, dispatch }, filters) {
      return await SalesApi.get_orders(filters)
        .then((response) => {
          commit("set_orders", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar cuentas por cobrar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    selectOrder({ commit }, data) {
      commit("set_order", data);
    },
    async storeAmortize({ dispatch }, payment) {
      return await SalesApi.amortize(payment)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El pago se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getOrders");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al registrar pago, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async storeCreditNote({ dispatch }, creditNote) {
      return await SalesApi.storeCreditNote(creditNote)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La anulación de la venta se realizó de forma correcta.",
            },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al anular la venta, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async getSaleByStation({ commit, dispatch }, filters) {
      return await SalesApi.get_by_station(filters)
        .then((response) => {

          const data = {
            set_sale_station: response.data.id,
            set_cart: response.data.detail,
            set_customer_id: response.data.customer_id,
            set_customer: response.data.customer,
            set_worker: response.data.worker,
            set_worker_id: response.data.worker_id,
          }
          commit("set_get_sale_by_station", data);
          // commit("set_sale_station", response.data.id);
          // commit("set_cart", response.data.detail);
          // commit("set_customer_id", response.data.customer_id);
          // commit("set_customer", response.data.customer);
          // commit("set_worker", response.data.worker);
          // commit("set_worker_id", response.data.worker_id);
          if (response.data.date_invoice) {
            commit("set_date_invoice", response.data.date_invoice);
          }
          dispatch("calulateAmounts");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al obtener datos de venta, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async storeByStation({ commit, dispatch }, sale) {
      return await SalesApi.storeByStation(sale)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Los datos se guardaron de forma correcta.",
            },
            { root: true }
          );
          commit("set_status_operation", true);
          dispatch("clearData");
          dispatch("stations/selectStation", null, { root: true });
          dispatch(
            "stations/getStations",
            { office_id: sale.office_id },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al guardar datos, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async updateByStation({ commit, dispatch }, sale) {
      return await SalesApi.updateByStation(sale)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Los datos se guardaron de forma correcta.",
            },
            { root: true }
          );
          commit("set_status_operation", true);
          dispatch("clearData");
          dispatch("stations/selectStation", null, { root: true });
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al guardar datos, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async storePaymentByStation({ commit, dispatch }, sale) {
      return await SalesApi.storePaymentByStation(sale)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La venta se realizó de forma correcta.",
            },
            { root: true }
          );
          commit("set_status_operation", true);
          commit("set_sale", response.data);
          dispatch("clearData");
          dispatch("stations/selectStation", null, { root: true });
          dispatch(
            "stations/getStations",
            { office_id: sale.office_id },
            { root: true }
          );
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al registrar la venta, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },

    async getCotizaciones({ commit, dispatch }, filters) {
      return await CotizacionesApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
        })
          commit("set_sale", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar las cotizaciones, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },

    async getLastOrderCode({ commit, dispatch }, sale) {
      return await SalesApi.getLastOrderCode()
        .then((response) => {
          if (response.data.order_code) {
            commit(
              "set_last_order_code",
              parseInt(response.data.order_code) + 1
            );
          } else {
            commit("set_last_order_code", 1);
          }
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al obtener ultimo codigo.",
            },
            { root: true }
          );
        });
    },
    
    async getCotizacionById({ commit, dispatch }, filters) {
      console.log("filtersss ::::::>>>> ", filters)
      return await CotizacionesApi.getCotizacionById(filters)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al obtener ultimo codigo.",
            },
            { root: true }
          );
        });
    },
  },
};
